export const splashImgDimensions = { width: 500, height: 500 };
